module.exports = __webpack_public_path__ + "img/mesa_l001m.85eb56a4.png";